import { TokenCheckerService } from '@qima-labs/app/shared/services/token-checker-services/token-checker.service';
import { OverlayModule } from '@qsp-ui-library/components/overlay/overlay.module';
import { AppOverlayService } from '@qsp-ui-library/services/modal-services/app-overlay/app-overlay.service';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  selector: 'app-qima-labs-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [TokenCheckerService],
  imports: [CommonModule, RouterOutlet, OverlayModule],
})
export class AppComponent implements OnInit {
  public isLoading: boolean = false;

  public constructor(
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _appOverlayService: AppOverlayService,
    private readonly _tokenCheckerService: TokenCheckerService
  ) {}

  public ngOnInit(): void {
    this._watch();
    this._initData();
  }

  private _initData(): void {
    this._tokenCheckerService.startTokenChecker();
  }

  private _watch(): void {
    this._appOverlayService.isLoading$.pipe(untilDestroyed(this)).subscribe((isLoading: boolean): void => {
      this.isLoading = isLoading;
      this._changeDetectorRef.detectChanges();
    });
  }
}
